import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import type { Appointment } from '@app-types/reception';
import { AppointmentRow } from './AppointmentRow';

interface AppointmentTableProps {
  appointments: Appointment[];
  loading?: boolean;
  error?: string | null;
  onCheckin: (id: string) => void;
  onStartConsultation: (id: string) => void;
  onFinish: (id: string) => void;
  onCancel: (id: string) => void;
}

export const AppointmentTable: React.FC<AppointmentTableProps> = ({
  appointments,
  loading,
  error,
  onCheckin,
  onStartConsultation,
  onFinish,
  onCancel
}) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }

  if (appointments.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Nu exista programari pentru aceasta zi
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Ora
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Animal
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Proprietar
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Medic
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Tip serviciu
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Status
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight={600}>
                Actiuni
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {appointments.map((appointment) => (
            <AppointmentRow
              key={appointment.id}
              appointment={appointment}
              onCheckin={onCheckin}
              onStartConsultation={onStartConsultation}
              onFinish={onFinish}
              onCancel={onCancel}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

